import { render, staticRenderFns } from "./WorkforceLeavePage.vue?vue&type=template&id=8b82587e&scoped=true&"
import script from "./WorkforceLeavePage.vue?vue&type=script&lang=js&"
export * from "./WorkforceLeavePage.vue?vue&type=script&lang=js&"
import style0 from "./WorkforceLeavePage.vue?vue&type=style&index=0&id=8b82587e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b82587e",
  null
  
)

export default component.exports